module.exports = __webpack_public_path__ + "2349319bc86d4ba4f25aa4e38e1019b8.svg";